import { __decorate } from "tslib";
import { Component, Vue, Prop, Inject } from "../../vue";
let HelperTooltip = class HelperTooltip extends Vue {
  get documentBody() {
    var _this$devToolDoc;
    return ((_this$devToolDoc = this.devToolDoc) === null || _this$devToolDoc === void 0 ? void 0 : _this$devToolDoc.body) || document.body;
  }
  render() {
    return this.componentType === 'tooltips' ? this.renderToolTips() : this.renderPopover();
  }
  renderToolTips() {
    const h = this.$createElement;
    return h("a-tooltip", {
      "attrs": {
        "title": this.title,
        "placement": this.placement,
        "getPopupContainer": () => this.documentBody
      }
    }, [this.getContentSlots()]);
  }
  renderPopover() {
    const h = this.$createElement;
    return h("a-popover", {
      "attrs": {
        "title": this.title,
        "placement": this.placement,
        "getPopupContainer": () => this.documentBody
      }
    }, [h("template", {
      "slot": "content"
    }, [this.getContentSlots()]), this.renderCustomTemplate()]);
  }
  getContentSlots() {
    const h = this.$createElement;
    return this.$scopedSlots.content ? this.$scopedSlots.content({}) : h("a-icon", {
      "attrs": {
        "type": this.iconType || 'exclamation-circle',
        "theme": this.iconTheme
      },
      "style": {
        color: this.iconColor
      }
    });
  }
  renderCustomTemplate() {
    const h = this.$createElement;
    if (typeof this.$scopedSlots.default === 'function') {
      return this.$scopedSlots.default({});
    }
    return h("a-icon", {
      "attrs": {
        "type": this.iconType || 'exclamation-circle',
        "theme": this.iconTheme
      },
      "style": {
        color: this.iconColor
      }
    });
  }
};
__decorate([Inject('devToolDoc')], HelperTooltip.prototype, "devToolDoc", void 0);
__decorate([Prop()], HelperTooltip.prototype, "title", void 0);
__decorate([Prop()], HelperTooltip.prototype, "placement", void 0);
__decorate([Prop()], HelperTooltip.prototype, "iconType", void 0);
__decorate([Prop({
  default: 'tooltips'
})], HelperTooltip.prototype, "componentType", void 0);
__decorate([Prop()], HelperTooltip.prototype, "iconTheme", void 0);
__decorate([Prop()], HelperTooltip.prototype, "iconColor", void 0);
HelperTooltip = __decorate([Component({
  name: 'HelperTooltip'
})], HelperTooltip);
export default HelperTooltip;
//# sourceMappingURL=index.js.map
